export default __webpack_public_path__ + "static/media/imgLight7.de6f8fac.png";